const GuideContainer: React.FC = () => {
  return (
    <div className="guide-container">
      <div className="row">
        <div className="col-contain">
          <div className="guide-left-contain">
            <h1 className="guide-title">Check Out Our Guides</h1>
            <p className="guide-text">
              Custom guides curated for the CEO.CA community
            </p>
          </div>
        </div>
        <div className="col-contain">
          <div className="guide-right-contain">
            <h4>
              <a href="/guides/basics" className="guide-link">
                Getting started basics
              </a>
            </h4>
            <h4>
              <a href="/guides/level2" className="guide-link">
                Level 2 trading guide
              </a>
            </h4>
            <h4>
              <a href="/guides/paper" className="guide-link">
                Paper trades guide
              </a>
            </h4>
            <h4>
              <a href="/guides/moderation" className="guide-link">
                Moderation policies
              </a>
            </h4>
            <h4>
              <a href="/guides" className="guide-link">
                View all guides
              </a>
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuideContainer;
